import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { AUTH_API_BASE_URL, queryKeys } from '../../constants';
import { IUserRoles, ListModelItems } from '../../index';

async function getMyRoles(onGetErrorMessage?: string): Promise<ListModelItems<IUserRoles>> {
    const { data } = await axios.get(`${AUTH_API_BASE_URL}/v1/authz/acls`, {
        params: { limit: 1000 },
        errorMessage: onGetErrorMessage,
    });

    return data;
}

export const useGetMyUserRoles = (enabled: boolean) => {
    const { t } = useTranslation();

    return useQuery<ListModelItems<IUserRoles>, AxiosError>({
        queryKey: [queryKeys.AuthRoles],
        queryFn: () => getMyRoles(t('getUserRolesError')),
        enabled,
    });
};
